<template>
    <div class="menu-container">
        <div class="menu-header">
            <svg-icon icon="agrisoy"/> <span v-if="!isCollapsedMenu" class="label ellipsis">Gestão Agrisoy</span>
        </div>
        <ul class="menu" :class="menuDesktopState">
            <li v-for="(menu, idx) in menuItems"
                :class="{active: menu.active}"
                @click="menuClick(menu.group)"
                :key="idx">
                <router-link :to="menu.to" v-ripple-tap class="item">
                    <svg-icon :icon="menu.icon"/>
                    <transition name="badge-menu">
                        <span v-if="crudNotifications[menu.group] && crudNotifications[menu.group].content"
                              :key="menu.group"
                              class="badge"
                              :class="crudNotifications[menu.group].color">{{crudNotifications[menu.group].content}}</span>
                    </transition>
                    <span class="label">{{menu.label}}</span>
                </router-link>
                <div v-if="menu.submenu" class="smenu">
                    <router-link :key="item.label"
                                 :title="item.label"
                                 v-for="item in menu.submenu"
                                 v-ripple-tap
                                 :class="{active: item.active}"
                                 :to="item.to"><svg-icon :icon="item.icon"/><span>{{item.label}}</span></router-link>
                </div>
            </li>
        </ul>

        <button type="button" @click="collapseMenu">
            <svg-icon :icon="this.menuDesktopState === 'collapsed' ? 'arrow-circle-right' : 'arrow-circle-left'"/>
        </button>
    </div>
</template>

<script>
    import {createNamespacedHelpers, mapMutations, mapGetters, mapActions} from 'vuex'
    import menuItems from './menu.json'
    import StorageUtils from '@/utils/StorageUtils'
    const userStore = createNamespacedHelpers('users');
    export default {
        name: "Menu",
        data() {
            return {
                previousStateMenu: null
            }
        },
        methods: {
            collapseMenu() {
                this.changeMenuState(this.isCollapsedMenu ? 'expanded' : 'collapsed')
            },
            confirmLogout() {
                if (confirm('Deseja realmente sair do sistema?')) {
                    this.logout();
                }
            },
            menuClick(group) {
                const item = this.crudNotifications[group];
                if (item) {
                    const notification = {...this.crudNotifications};
                    delete notification[group];
                    this.changeCrudNotifications(notification);
                }
            },
            ...userStore.mapActions(['logout']),
            ...mapMutations(['addModal', 'destroyModal', 'changeMenuState']),
            ...mapActions(['changeCrudNotifications'])
        },
        computed: {
            ...mapGetters(['menuDesktopState', 'crudNotifications']),
            menuItems: {
                get: () => menuItems.filter(i => {
                    if (i.submenu) {
                        i.submenu = i.submenu.filter(s => {
                            return !s.requireAnyProfiles || StorageUtils.userIsProfile(s.requireAnyProfiles)
                        });
                    }

                    if (i.requireAnyProfiles) return StorageUtils.userIsProfile(i.requireAnyProfiles);

                    return true
                })
            },
            isCollapsedMenu() {
                return this.menuDesktopState === 'collapsed'
            }
        },
        beforeCreate() {
            const allSubs = [];
            const currentRoute = this.$router.currentRoute;
            menuItems.forEach(m => {
                m.badge = {
                    color: 'red',
                    content: null
                };
                if (m.submenu)
                    m.submenu.forEach(i => {
                        i.active = false;
                        i.father = m;
                        i.father.active = false;
                        allSubs.push(i);
                    });
                else m.active = m.to === currentRoute.path;
            });

            const newRegex = /\/new$/;
            const editRegex = /.+(\/\d+\/edit)$/;

            for (let i = 0; i < allSubs.length; i++) {
                const item = allSubs[i];
                item.active = item.to === currentRoute.path;

                if (!item.active && editRegex.test(currentRoute.path)) {
                    item.active = item.to.replace(newRegex, currentRoute.path.replace(editRegex, '$1')) === currentRoute.path
                }

                if (item.active) {
                    item.father.active = item.active;
                    break;
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../assets/css/variables";

    .menu-container{

        button {
            float: right;
            margin-top: 20px;
            background-color: $theme_color_one;
            border: none;
            color: #fff;
            outline: none;
            border-bottom-left-radius: 5px;
            border-top-left-radius: 5px;

            &:active svg {
                transform: scale(.9);
            }

            svg {
                width: 1em;
                height: 1em;
            }
        }
    }

    .menu-header {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        height: 50px;
        overflow: hidden;

        color: $theme_color_eleven;

        .label {
            margin-left: 15px;
        }
        svg {
            margin-left: 11px;
            width: 1.7em;
            height: 1.7em;
        }
    }
    .menu {
        list-style: none;
        text-decoration: none;
        color: $theme_color_four;
        margin: 0;
        padding: 0;

        li {
            width: 100%;
            border-top: 1px solid $theme_color_two;
            overflow: hidden;

            &:hover .smenu, &.active .smenu {
                max-height: 20em;
            }
        }

        .item {
            padding: 10px 15px;
            display: block;
            background: $theme_color_one;
            position: relative;

            .badge {
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                left: 26px;
                top: 2px;
                font-size: .8em;
                border-radius: 10px;
                height: 20px;
                min-width: 20px;
                padding: 0 3px;
                font-weight: 700;
                box-shadow: 1px 1px 2px 0 rgba(0,0,0,.5);

                &.red {
                    background-color: $badge_red;
                }
                &.black {
                    background-color: $badge_black;
                    color: $market_place_buyer;
                }
            }

            &:before {
                content: '';
                position: absolute;
                width: 14px;
                height: 14px;
                background: $theme_color_one;
                left: 20px;
                bottom: -7px;
                transform: rotate(45deg);
            }

            .label {
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
            }

            svg {
                margin-right: 16px;
            }
        }

        a {
            color: $theme_color_four;
            font-size: .9em;
            text-decoration: none;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-weight: 300;
        }

        svg {
            width: 20px;
            height: 20px;
        }

        .smenu {
            background: $theme_color_six;
            overflow: hidden;
            max-height: 0;
            transition: max-height .3s linear;

            a {
                padding: 10px 20px;
                width: 100%;
                display: block;
                font-size: .8em;
                margin: 4px 0;
                position: relative;
                transition: color .2s ease;
                color: $theme_color_five;

                &.active, &:hover {
                    color: $theme_color_four;
                }

                &:before {
                    content: '';
                    position: absolute;
                    width: 6px;
                    height: 100%;
                    background: $submenu_active;
                    left: 0;
                    top: 0;
                    transition: .3s;
                    opacity: 0;
                }

                &:hover:before {
                    opacity: .3;
                }

                &.active:before {
                    opacity: 1;
                }

                svg {
                    width: 18px;
                    height: 18px;
                    margin-right: 14px;
                }
            }
        }
    }
</style>
